import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
//helper
import debounce from "../../helper/debounce";
// components
import CardsFilter from "../card-filters/cardsMap";
import FacilitiesList from "../facilitiesList";
import EmptyResults from "./emptyResults";
import GMap from "../facilitiesList/map";
import MobileViewToggler from "./mobileViewToggler";

/**
 * Renders a layout map component with a list of facilities and a Google Map.
 * @returns {JSX.Element} The layout map component.
 */
const LayoutMap = () => {
	const [selectedCard, setSelectedCard] = useState(null);
	const [toggleMap, setToggleMap] = useState(true);
	const [mobileView, setMobileView] = useState(false);
	const [isMapLoaded, setMapLoaded] = useState(false);
	const layoutBlock = useRef(null);
	const mapBlock = useRef(null);
	const facilityList = useSelector((state) => state.facilityList);
	const global = useSelector((state) => state.global);
	const options = facilityList.facilities;
	const selectCard = (id) => {
		setSelectedCard(id);
	};
	useEffect(() => {
		setOffset();
		if (window.innerWidth < 1024) {
			setMobileView(true);
		}
	}, []);
	useEffect(() => {
		if (toggleMap) {
			setOffset();
		}
		if(facilityList.loading){
			setToggleMap(true);
		}
		if(!facilityList.facilities.length) {
			setOffset();
		}
	}, [toggleMap, facilityList]);
	useEffect(() => {
		const debouncedHandleResize = debounce(function handleResize() {
			setOffset();
			if (window.innerWidth < 1024) {
				setMobileView(true);
			} else {
				setMobileView(false);
			}
		}, 500);

		window.addEventListener("resize", debouncedHandleResize);
		return (_) => {
			window.removeEventListener("resize", debouncedHandleResize);
		};
	});
	const setOffset = () => {
		if (layoutBlock.current !== null) {
			document.documentElement.style.setProperty(
				"--offset-top",
				layoutBlock.current.offsetTop + "px",
			);
		}
		if (mapBlock.current !== null) {
			const windowHeight = document
				.querySelector("html")
				.getBoundingClientRect().height;

			document.documentElement.style.setProperty(
				"--offset-top-map",
				windowHeight - mapBlock.current.getBoundingClientRect().top + "px",
			);
		}
	};
	return (
		<>
			<div className={`layout-full`} ref={layoutBlock}>
				<CardsFilter />
				{!facilityList.facilities.length ? (
					<EmptyResults localization={global.localization} />
				) : null}
				{facilityList.facilities.length && isMapLoaded ? (
					<aside
						className={`layout-full__aside ${toggleMap ? "is-hidden" : ""}`}>
						<FacilitiesList
							options={options}
							scrollTo={selectedCard}
							toggleMap={toggleMap}
						/>
					</aside>
				) : null}

				{!mobileView || facilityList.facilities.length ? (
					<div
						className={`layout-full__main ${!toggleMap ? "is-hidden" : ""}`}
						ref={mapBlock}>
						<GMap
							callback={selectCard}
							options={options}
							optionsLoading={facilityList.loading}
							toggleMap={toggleMap}
							isLoadedMap={setMapLoaded}
						/>
					</div>
				) : null}
			</div>

			{facilityList.facilities.length ? (
				<MobileViewToggler
					state={toggleMap}
					labels={{
						listview: global.localization.listview,
						mapview: global.localization.mapview,
					}}
					callback={setToggleMap}
				/>
			) : null}
		</>
	);
};
export default LayoutMap;
